import type { ReactNode } from 'react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { Dialog as HeadlessDialog } from '@headlessui/react';

interface DialogProps {
  isOpen?: boolean;
  onClose: () => void;
  className?: string;
  backdropClassName?: string;
  children?: ReactNode;
}

const Dialog: React.FC<DialogProps> = (props) => {
  const backdropClassNames = twMerge(
    'fixed inset-0 flex md:items-center justify-center z-50 backdrop-blur-[3px]',
    props.backdropClassName,
  );
  const dialogClassNames = twMerge(
    'flex flex-col',
    'bg-gradient-to-r from-[rgba(231, 230, 232, 0.08)] to-[rgba(231, 230, 232, 0.08)] bg-white',
    'border border-gray100 rounded-2xl',
    props.className,
  );

  return (
    <HeadlessDialog
      onClose={props.onClose}
      open={props.isOpen}
      className={props.className}
    >
      <div className={backdropClassNames}>
        <HeadlessDialog.Panel className={dialogClassNames}>
          {props.children}
        </HeadlessDialog.Panel>
      </div>
    </HeadlessDialog>
  );
};

export default Dialog;
